<template>
  <div class="change-avatar">
    <p
      class="text-center"
      style="margin-bottom: 10px;"
      v-viewer
    >
      <img
        :src="imgDataUrl"
        width="300"
        height="300"
        alt="Avatar"
        @error="(e) => {e.target.src='/img/avatar.png'}"
      >
    </p>
    <a
      class="btn btn-primary"
      @click="toggleShow"
    >{{ $t('label.uploadYourAvatar') }}</a>
    <my-upload
      field="avatar"
      @crop-success="cropSuccess"
      @crop-upload-success="cropUploadSuccess"
      @crop-upload-fail="cropUploadFail"
      v-model="show"
      :width="300"
      lang-type="en"
      :height="300"
      :url="`${apiUrl}/api/auth/backend/change-avatar`"
      :params="params"
      :headers="headers"
      img-format="png"
    />
  </div>
</template>

<script>
import 'babel-polyfill'
import myUpload from 'vue-image-crop-upload'
import { mapGetters } from 'vuex'

export default {
  name: 'ChangeAvatar',
  components: {
    'my-upload': myUpload
  },
  data () {
    return {
      apiUrl: process.env.VUE_APP_API,
      show: false,
      params: {
        user_id: null,
        name: 'avatar'
      },
      headers: null,
      imgDataUrl: ''
    }
  },
  computed: {
    ...mapGetters([
      'currentUser'
    ])
  },
  watch: {
    userAvatar () {
      if (this.userAvatar) {
        this.imgDataUrl = this.userAvatar
      }
    }
  },
  methods: {
    toggleShow () {
      this.show = !this.show
    },
    cropSuccess (imgDataUrl, field) {
    },
    cropUploadSuccess (data) {
      if (data.data) {
        const result = data.data
        this.$store.dispatch('user/clearUser')
        this.$store.dispatch('user/setUser', { user: result.user })
        this.$store.dispatch('user/setRoles', result.roles)
        this.$store.commit('user/setPermissions', result.permissions)
      }
    },
    cropUploadFail (status, field) {
    }
  },
  mounted () {
    const token = localStorage.getItem(process.env.VUE_APP_TOKEN)

    this.headers = {
      Authorization: `Bearer ${token}`,
      Accept: 'application/json'
    }

    this.imgDataUrl = this.userAvatar
  }
}
</script>

<style scoped>
.change-avatar {
  align-content: center;
  text-align: center;
  padding-top: 10vh;
  padding-bottom: 10vh;
}
</style>
